import { BrowserRouter, Routes, Route, } from "react-router-dom";
import Homepage from '../HomePage'

const AllRoute = () => {

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route exact path='/' element={<Homepage />} />
          {/* <Route path='404' element={<ErrorPage />} /> */}
        </Routes>
      </BrowserRouter>

    </div>
  );
}

export default AllRoute;
